<template>
  <div class="notice">
    <van-swipe class="my-swipe" @change="onChange" v-if="banners.length != 0">
      <van-swipe-item v-for="(item, i) in banners" :key="i" @click="goDetail(item.noticeId)">
        <!-- <div class="notice-box">
          <div v-if="showNotice && notice.length != 0">
            <div class="notice-box-title" @click="goDetail(notice[0].noticeId)">
              {{ notice[0].title }} <span>{{ notice[0].createTime }}</span>
            </div>

            <div class="notice-box-close" @click="showNotice = false">
              <van-image
                :src="require('../assets/img/close.png')"
                fit="contain"
                width="16px"
                height="16px"
              />
            </div>
          </div>
        </div> -->
        <van-image :src="item.url" fit="cover" height="100%" width="100%" />
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">
          <span v-for="(item, i) in banners" :key="i" :class="{ active: i == current }"></span>
        </div>
      </template>
    </van-swipe>
    <van-image v-else :src="defaultImg" fit="cover" height="132px" width="100%" />
  </div>
</template>

<script>
import { getBannerList, getNoticeList } from '@/api/common'
export default {
  name: 'Notice',
  data() {
    return {
      showNotice: true,
      current: 0,
      banners: [],
      defaultImg: require('../assets/img/banner-2.png'),
      notice: [
        {
          noticeId: '',
          title: '',
          createTime: '',
          content: '',
        },
      ],
    }
  },
  // watch: {
  //   $route(val) {
  //     console.log('改变路由', val)
  //   },
  // },
  created() {},
  mounted() {
    this.getNotices()
    //this.getBanners()
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: '/notice/detail',
        query: {
          id: id,
        },
      })
    },
    getBanners() {
      getBannerList({}).then((res) => {
        this.banners = res.data
      })
    },
    getNotices() {
      getNoticeList({}).then((res) => {
        //this.notice = res.data
        this.banners = res.data
      })
    },
    onChange(index) {
      this.current = index
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.notice {
  position: relative;
  border-radius: 4px;
  margin-bottom: 10px;

  .notice-box {
    position: absolute;
    top: 0;
    background-color: rgba(255, 255, 255, 0.8);
    width: 100%;
    // height: 45px;
    z-index: 99;
    border-radius: 4px;
    & > div {
      padding: 8px;
    }
    &-title {
      font-size: 14px;
      font-weight: 500;
      background: url('../assets/img/notice-icon.png') 0 center no-repeat;
      background-size: 18px;
      padding-left: 20px;
      span {
        position: absolute;
        right: 16px;
        font-size: 12px;
        font-weight: normal;
      }
    }
    &-rmk {
      width: 100%;
      /* 超出部分隐藏 */
      overflow: hidden;
      p {
        margin: 0;
        font-size: 12px;
        /* 控制文字在一行内显示 */
        word-break: keep-all;
        white-space: nowrap;
        /* 添加定义好的动画，并均匀移动（linear）且不断重复（infinite） */
        animation: 20s wordsLoop linear infinite;
      }
    }
    &-close {
      position: absolute;
      top: 0;
      right: 0;
      width: 16px;
      height: 16px;
      z-index: 999;
    }
  }
  .my-swipe {
    border-radius: 4px;
    height: 132px;
    .custom-indicator {
      position: absolute;
      right: 5px;
      bottom: 8px;
      padding: 2px 5px;
      font-size: 12px;
      // background: rgba(0, 0, 0, 0.1);
      span {
        display: inline-block;
        width: 4.25px;
        height: 3px;
        background-color: #dad9de;
        margin-right: 2px;
        &.active {
          width: 6.5px;
          background-color: #d5001c;
        }
      }
    }
  }
}

/* 添加动画，表示从右到左移动距离 */
@keyframes wordsLoop {
  0% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
